import React from "react";
import { ClockIcon } from "../../../../Icons";
import { formatTime12 } from "./staffScheduleTime";

/** Compact time block for schedule grid cells */
const StaffScheduleTimeChip = ({ slot }) => {
  const rangeLabel = `${formatTime12(slot.startTime)} – ${formatTime12(slot.endTime)}`;
  const tip = slot.notes ? `${rangeLabel} — ${slot.notes}` : rangeLabel;

  return (
    <div
      className="w-[98px] mx-auto rounded-lg border border-indigo-200 bg-indigo-50/90 px-1.5 py-1.5 shadow-sm"
      title={tip}
    >
      <div className="flex items-center justify-center text-indigo-500 mb-0.5">
        <ClockIcon size={11} />
      </div>
      <p className="text-[10px] font-semibold text-indigo-900 text-center leading-tight tabular-nums">
        {formatTime12(slot.startTime)}
      </p>
      <p className="text-[9px] font-medium text-indigo-400 text-center leading-none py-0.5">
        to
      </p>
      <p className="text-[10px] font-semibold text-indigo-900 text-center leading-tight tabular-nums">
        {formatTime12(slot.endTime)}
      </p>
    </div>
  );
};

export default StaffScheduleTimeChip;
